module.exports = {
	siteName: 'mdc',
	site: {
		mancity: {},
	},
};
